module.exports = angular.module('cartographer.plugin.layer.riverfly', [])

module.exports.run $DI (
  crtLog
  crtLayer
  crtFeatureLayer
  crtMapCollaborationModel
  crtMapPermissionModel
) ->
  riverfly = crtFeatureLayer.create({
    id: "riverfly"
    name: "Riverfly"
    atlasMapId: "riverfly"
    defaultMapEngine: "atlas"
    collaborationModel: crtMapCollaborationModel.CrossWorkspace
    permissionModel: crtMapPermissionModel.Public
    selectionRadius: 10
    attributeGroups: []
  })

  urbanRiverfly = crtFeatureLayer.create({
    id: "urbanRiverfly"
    name: "Urban Riverfly"
    atlasMapId: "urbanRiverfly"
    defaultMapEngine: "atlas"
    collaborationModel: crtMapCollaborationModel.CrossWorkspace
    permissionModel: crtMapPermissionModel.Public
    selectionRadius: 10
    attributeGroups: []
  })

  extendedRiverflyWaterQuality = crtFeatureLayer.create({
    id: "extendedRiverflyWaterQuality"
    name: "Extended Riverfly Water Quality"
    atlasMapId: "extendedRiverflyWaterQuality"
    defaultMapEngine: "atlas"
    collaborationModel: crtMapCollaborationModel.CrossWorkspace
    permissionModel: crtMapPermissionModel.Public
    selectionRadius: 10
    attributeGroups: []
  })

  extendedRiverflySiltAndFlow = crtFeatureLayer.create({
    id: "extendedRiverflySiltAndFlow"
    name: "Extended Riverfly Silt and Flow"
    atlasMapId: "extendedRiverflySiltAndFlow"
    defaultMapEngine: "atlas"
    collaborationModel: crtMapCollaborationModel.CrossWorkspace
    permissionModel: crtMapPermissionModel.Public
    selectionRadius: 10
    attributeGroups: []
  })

  riverflySite = crtFeatureLayer.create({
    id: "riverflySite"
    name: "Riverfly Sites"
    atlasMapId: "riverflySite"
    defaultMapEngine: "atlas"
    collaborationModel: crtMapCollaborationModel.CrossWorkspace
    permissionModel: crtMapPermissionModel.Public
    selectionRadius: 10
    attributeGroups: []
  })

  crtLayer.registerPlugin(riverfly)
  crtLayer.registerPlugin(urbanRiverfly)
  crtLayer.registerPlugin(extendedRiverflyWaterQuality)
  crtLayer.registerPlugin(extendedRiverflySiltAndFlow)
  crtLayer.registerPlugin(riverflySite)

  return
